import BasePreset from '../base/BasePreset.js'
import fragSrc    from '../../shaders/presets/minimal/fragment.glsl'

export default class MinimalPreset extends BasePreset {
    constructor() {
        super()
        this.id   = 'minimal'
        this.name = 'Minimal'
        this.plan = 'free'
        this.defaultObjectColor = '#6699bb'
        this.defaultBgColor     = '#03060e'
    }

    init(canvas) {
        this._setup(canvas, fragSrc)
        const gl = this.gl
        this.uniforms.uObjectColor = gl.getUniformLocation(this._program, 'uObjectColor')
        this.uniforms.uBgColor     = gl.getUniformLocation(this._program, 'uBgColor')
        this.uniforms.uShapeIdx    = gl.getUniformLocation(this._program, 'uShapeIdx')
        this.uniforms.uLineCount   = gl.getUniformLocation(this._program, 'uLineCount')
        this.uniforms.uScale       = gl.getUniformLocation(this._program, 'uScale')
    }

    getSchema(plan) {
        if (plan === 'free') return []
        const fields = [
            { key: 'objectColor', type: 'color', label: 'Ring Color',  default: this.defaultObjectColor },
            { key: 'bgColor',     type: 'color', label: 'Background',  default: this.defaultBgColor },
        ]
        if (plan === 'pro') {
            fields.push(
                {
                    key: 'shapeIdx', type: 'select', label: 'Ring Shape',
                    options: [
                        { value: 0, label: 'Circle' },
                        { value: 1, label: 'Square' },
                        { value: 2, label: 'Wave' },
                        { value: 3, label: 'Star' },
                    ],
                    default: 0,
                },
                { key: 'lineCount', type: 'range', label: 'Ring Count', min: 1, max: 9, step: 1, default: 6 },
            )
        }
        return fields
    }

    _applyConfigUniforms() {
        const gl = this.gl
        const [or, og, ob] = this._hexToRgb(this._config.objectColor ?? this.defaultObjectColor)
        gl.uniform3f(this.uniforms.uObjectColor, or, og, ob)
        const [br, bg, bb] = this._hexToRgb(this._config.bgColor ?? this.defaultBgColor)
        gl.uniform3f(this.uniforms.uBgColor, br, bg, bb)
        gl.uniform1i(this.uniforms.uShapeIdx,  Math.round(Number(this._config.shapeIdx  ?? 0)))
        gl.uniform1i(this.uniforms.uLineCount, Math.round(Number(this._config.lineCount ?? 6)))
        gl.uniform1f(this.uniforms.uScale,     Number(this._config.scale ?? 1.0))
    }
}
